import { useIntl } from '@weenat/wintl';
import { useClient } from '../../../ClientProvider';
import schemas from '../../../schemas';
import useMutation from '../../../useMutation';
import useOrderedFields from '../../useOrderedFields';
import { useRef } from 'react';
import { useHandleDecitraitConnectErrorAndSuccess } from './useHandleDecitraitConnectErrorAndSuccess';
const schema = schemas.decitrait.connect;
export const useDecitraitConnect = (props) => {
    const client = useClient();
    const formRef = useRef();
    const successAndErrorHandler = useHandleDecitraitConnectErrorAndSuccess({
        key: 'create-user',
        org: props.org,
        useToasts: props.useToasts
    });
    const [connect, { isPending, isError, isSuccess }] = useMutation(client.decitrait.connect(), {
        onError: successAndErrorHandler.onError,
        onSuccess: () => {
            props.onSuccess?.();
            successAndErrorHandler.onSuccess();
        }
    });
    const { t } = useIntl();
    const handleSubmit = (values) => connect({ ...values, organizationId: props.org.id });
    const fieldProps = useOrderedFields(['epicureUsername', 'password'], formRef, {
        shared: { isDisabled: isPending }
    });
    return {
        props: {
            form: {
                schema,
                initialValues: props.initialValues,
                onSubmit: handleSubmit,
                formRef
            },
            field: { ...fieldProps, password: { ...fieldProps.password, withStrengthMeter: false } },
            submitButton: {
                topPadded: true,
                isDisabled: isPending,
                isError,
                isSuccess,
                children: t('models.account.actions.login')
            }
        }
    };
};
